/* eslint-disable no-restricted-globals */

import { useEffect } from 'react';
import NProgress from 'nprogress';
import StyledProgressBar from './styles';

export default function ProgressBar() {
  useEffect(() => {
    NProgress.configure({ showSpinner: false });

    const handleAnchorClick = (event) => {
      const targetUrl = event.currentTarget.href;
      const currentUrl = location.href;
      if (targetUrl !== currentUrl) {
        NProgress.start();
      }
    };

    const handleMutation = () => {
      const anchorElements = document.querySelectorAll('a');
      anchorElements.forEach((anchor) => anchor.addEventListener('click', handleAnchorClick));
    };

    const mutationObserver = new MutationObserver(handleMutation);
    mutationObserver.observe(document, { childList: true, subtree: true });

    const originalPushState = window.history.pushState;
    window.history.pushState = new Proxy(originalPushState, {
      apply: (target, thisArg, argArray) => {
        NProgress.done();
        return target.apply(thisArg, argArray);
      },
    });

    return () => {
      mutationObserver.disconnect();
      window.history.pushState = originalPushState;
      document
        .querySelectorAll('a')
        .forEach((anchor) => anchor.removeEventListener('click', handleAnchorClick));
    };
  }, []);

  return <StyledProgressBar />;
}
